import React from 'react';
import { 
  Plus, 
  Trash2, 
  Download, 
  Upload, 
  Play, 
  Edit, 
  MoreHorizontal, 
  Copy, 
  Search, 
  X, 
  Filter,
  Camera,
  RefreshCw,
  SwitchCamera,
  ChevronDown,
  CalendarRange
} from 'lucide-react';

export const PlusIcon = () => <Plus className="w-5 h-5" />;
export const DeleteIcon = () => <Trash2 className="w-5 h-5" />;
export const DownloadIcon = () => <Download className="w-5 h-5" />;
export const UploadIcon = () => <Upload className="w-5 h-5" />;
export const PlayIcon = () => <Play className="w-12 h-12 text-background" />;
export const EditIcon = () => <Edit className="w-4 h-4" />;
export const MoreIcon = () => <MoreHorizontal className="w-4 h-4" />;
export const CopyIcon = () => <Copy className="w-4 h-4" />;
export const FindSimilarIcon = () => <Search className="w-4 h-4" />;
export const CloseIcon = () => <X className="w-4 h-4" />;
export const FilterIcon = () => <Filter className="w-4 h-4" />;
export const CameraIcon = () => <Camera className="w-5 h-5" />;
export const RefreshIcon = () => <RefreshCw className="w-4 h-4" />;
export const SwitchCameraIcon = () => <SwitchCamera className="w-4 h-4" />;
export const TrashIcon = () => <Trash2 className="w-4 h-4" />;
export const ChevronDownIcon = () => <ChevronDown className="w-4 h-4" />;
export const PlannerIcon = ({ className }: { className?: string }) => <CalendarRange className={className || "w-4 h-4"} />;
